import connect from './connect'
import EditNotesModal from './EditNotesModal'

export default connect(EditNotesModal)
